// Import react elements
import { useContext, useEffect, useRef, useState } from "react";

// Import strich api calls
import { completePayPalBillingLink } from "api/APIStrichCalls";

// Import context function
import { AuthContext } from "global/context/AuthContext";

// Import hooks
import { useToast } from "global/hooks/useToast";



const PayPalBillingSuccess = () => {

    // Get the auth token
    const { token } = useContext(AuthContext);

    // Get the toast hook
    const { toastError } = useToast();

    // Track whether the completion call has already been made
    const hasCompletedLink = useRef(false);

    // Set the page status
    const [status, setStatus] = useState("loading");
    const [message, setMessage] = useState("Linking PayPal billing...");



    // Complete the PayPal billing link when the page loads
    useEffect(() => {

        // Stop the effect running more than once
        if (hasCompletedLink.current) { return; }

        // Mark the effect as already run
        hasCompletedLink.current = true;

        // Get the approval token from the url
        const params = new URLSearchParams(window.location.search);
        const approval_token = params.get("approval_token_id");

        // Check if the approval token was returned
        if (!approval_token) {

            setStatus("error");
            setMessage("Approval token not found. You can now close the tab.");
            return;

        }

        // Complete the billing link
        const completeLink = async () => {

            // Make the API call
            const response = await completePayPalBillingLink(token, approval_token);

            // Check if the call failed
            if (!response?.success) {

                toastError({
                    title: "Error",
                    message: response?.error_message || "Failed to complete PayPal billing link.",
                    autoCloseMs: 6000
                });

                setStatus("error");
                setMessage("Failed to link PayPal billing. You can now close the tab.");
                return;

            }

            // Update the page status
            setStatus("success");
            setMessage("You can now close the tab");

            // Create the channel shared with the Account page
            const paypalBillingChannel = new BroadcastChannel("paypal-billing");

            // Tell the Account page that PayPal billing has been linked
            paypalBillingChannel.postMessage("linked");

            // Close the channel once the message has been sent
            paypalBillingChannel.close();

            // Close this success tab
            setTimeout(() => {

                window.close();

            }, 500);

        };

        completeLink();

    }, [toastError, token]);



    return (

        <div style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "40px",
            textAlign: "center"
        }}>

            <div style={{
                maxWidth: "500px",
                width: "100%",
                padding: "40px",
                borderRadius: "16px",
                background: "#ffffff",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)"
            }}>

                <h2>PayPal Billing</h2>

                <br />

                <p>{message}</p>

                {status === "loading" ? (
                    <>
                        <br />
                        <p>Please wait...</p>
                    </>
                ) : null}

            </div>

        </div>

    );

};

export default PayPalBillingSuccess;